/**
 * @lectura/ui — közös designrendszer Lectura platformhoz.
 * Mély lila brand + meleg accent + modern marketplace-mintázat (kerekített kártyák,
 * gradiens hero, sötét lila lábléc).
 */
export * from './components/Avatar';
export * from './components/Badge';
export * from './components/Button';
export * from './components/Card';
export * from './components/CookieBanner';
export * from './components/EmptyState';
export * from './components/Footer';
export * from './components/Header';
export * from './components/Hero';
export * from './components/Input';
export * from './components/Logo';
export * from './components/Progress';
export * from './components/SectionHeading';
export * from './components/Sidebar';
export * from './components/Spinner';
export * from './components/StatCard';
export * from './components/Table';
export * from './components/Tabs';
export * from './components/Toast';

export * from './theme';
export { cn } from './utils/cn';
